"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.podcastXmlParser = void 0;
const constants_1 = require("../constants");
const fetch_1 = require("../fetch");
const transform_1 = require("../transform");
/**
 * Parses a podcast feed from various source types and returns podcast and episodes data,
 * along with iTunes information if available.
 *
 * @param source - A URL, iTunes ID, or XML string representing the podcast feed.
 * @param config - Optional configuration object for parsing options.
 * @returns An object containing the podcast and episodes data, along with iTunes information if available.
 * @throws If the source type is invalid, the feed URL cannot be retrieved from iTunes, or no feed is available to parse.
 */
const podcastXmlParser = (source_1, ...args_1) => __awaiter(void 0, [source_1, ...args_1], void 0, function* (source, config = {}) {
    let xmlText = "";
    let itunes;
    if (source instanceof URL) {
        xmlText = yield (0, fetch_1.fetchPodcast)(source, config);
    }
    else if (typeof source === "number") {
        itunes = yield (0, fetch_1.fetchItunes)(source);
        if (!(itunes === null || itunes === void 0 ? void 0 : itunes.feedUrl)) {
            throw new Error(constants_1.ERROR_MESSAGES.ITUNES_NO_FEED_URL);
        }
        xmlText = yield (0, fetch_1.fetchPodcast)(new URL(itunes.feedUrl), config);
    }
    else if (typeof source === "string") {
        xmlText = source;
    }
    else {
        throw new Error(constants_1.ERROR_MESSAGES.XML_INVALID_SOURCE);
    }
    if (!xmlText) {
        throw new Error(constants_1.ERROR_MESSAGES.XML_NO_FEED_TO_PARSE);
    }
    const { podcast, episodes } = (0, transform_1.transformPodcast)(xmlText);
    let paginatedEpisodes = episodes;
    if (config.start !== undefined && config.limit !== undefined) {
        paginatedEpisodes = episodes.slice(config.start, config.start + config.limit);
    }
    if (config.itunes && !itunes && podcast.feedUrl) {
        itunes = yield (0, fetch_1.fetchItunes)(podcast.title, podcast.feedUrl);
    }
    return { podcast, episodes: paginatedEpisodes, itunes };
});
exports.podcastXmlParser = podcastXmlParser;
